import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@mui/material";
import { getMessageLogDetail } from "../../connections/getMessageLogDetail";

const MessageLogDetail = () => {
  const { user: { user } } = useSelector((store) => store);
  const { id } = useParams();

  const { data, isLoading } = useQuery({
    queryKey: ["getMessageLogDetail", id],
    queryFn: () => getMessageLogDetail(user?.token, id),
    enabled: !!id && !!user?.token,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const log = data?.payload;

  const formatResponse = (val) => {
    if (!val) return null;
    try {
      return JSON.stringify(JSON.parse(val), null, 2);
    } catch {
      return val;
    }
  };

  return (
    <>
      <Header />
      <Sidebar activeClassName="message-logs" />
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to="/admin/message-logs">Message Logs</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Message Log Details</h3>
                            <div
                              style={{ display: "flex", alignItems: "center", gap: "10px" }}
                              className="doctor-search-blk"
                            >
                              <Link
                                to="/admin/message-logs"
                                className="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
                                style={{ minWidth: "100px", padding: "6px 12px", borderRadius: "6px" }}
                              >
                                <i className="feather-arrow-left me-2" />
                                Back
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {isLoading ? (
                      <Skeleton variant="rectangular" width="100%" height={430} />
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">ID:</span>{" "}
                                  <span className="text">{log?.id || "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Message Type:</span>{" "}
                                  <span className="text">{log?.message_type || "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Status:</span>{" "}
                                  <span className="text">{log?.status || "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Sender Type:</span>{" "}
                                  <span className="text">{log?.sender_type || "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Sender Id:</span>{" "}
                                  <span className="text">{log?.sender_id ?? "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Receiver Type:</span>{" "}
                                  <span className="text">{log?.receiver_type || "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Receiver Id:</span>{" "}
                                  <span className="text">{log?.receiver_id ?? "Empty"}</span>
                                </li>
                                {log?.error_details && (
                                  <li className="pb-1">
                                    <span className="title">Error Details:</span>{" "}
                                    <span className="text">{log.error_details}</span>
                                  </li>
                                )}
                                <li className="pb-1">
                                  <span className="title">Created At:</span>{" "}
                                  <span className="text">{log?.created_at || "Empty"}</span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>{" "}
                                  <span className="text">{log?.updated_at || "Empty"}</span>
                                </li>

                                {log?.message_content && (
                                  <li className="pb-1">
                                    <span className="title">Message Content:</span>{" "}
                                    <span className="text">{log.message_content}</span>
                                  </li>
                                )}

                              </ul>

                              {log?.message_response_id && (
                                <div className="pb-2">
                                  <span className="title">Message Response:</span>
                                  <pre
                                    style={{
                                      background: "#1e1e2e",
                                      color: "#cdd6f4",
                                      fontSize: 13,
                                      borderRadius: 8,
                                      padding: "12px 16px",
                                      marginTop: 8,
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {formatResponse(log.message_response_id)}
                                  </pre>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default MessageLogDetail;
